module.exports = __webpack_public_path__ + "img/tooldashboard@0.5x.286d59f0.png";